import { render } from "./CommentsSlider.vue?vue&type=template&id=676087a5"
import script from "./CommentsSlider.vue?vue&type=script&lang=js"
export * from "./CommentsSlider.vue?vue&type=script&lang=js"

import "./CommentsSlider.vue?vue&type=style&index=0&id=676087a5&lang=scss"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/CommentsSlider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "676087a5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('676087a5', __exports__)) {
    console.log('reload')
    api.reload('676087a5', __exports__)
  }
  
  module.hot.accept("./CommentsSlider.vue?vue&type=template&id=676087a5", () => {
    console.log('re-render')
    api.rerender('676087a5', render)
  })

}


export default __exports__